import {
  Banner,
  BannerActions,
  BannerContent,
  Button,
  StackLayout,
} from "@salt-ds/core";

import { CloseIcon } from "@salt-ds/icons";

interface NotificationBannerProps {
  message: string;
  type: "success" | "error";
  onClose?: () => void;
}

const NotificationBanner = ({
  message,
  type,
  onClose,
}: NotificationBannerProps) => {
  const role = type === "success" ? "status" : "alert";
  return (
    <StackLayout gap={3}>
      <Banner status={type}>
        <BannerContent role={role}>{message}</BannerContent>
        <BannerActions>
          <Button aria-label="close" variant="secondary" onClick={onClose}>
            <CloseIcon />
          </Button>
        </BannerActions>
      </Banner>
    </StackLayout>
  );
};

export default NotificationBanner;
